export * from './slider.component';
export * from './slider.module';
